<div class="flex flex-col gap-2 rounded-lg bg-interface-surface-0 p-3">
  <p-table [value]="priceItems()" size="small">
    <ng-template #header>
      <tr>
        <th>Incoterm</th>
        <th>Currency</th>
        <th>Amount</th>
      </tr>
    </ng-template>

    <ng-template #body let-priceItem>
      <tr>
        <td class="text-left">
          @if (verboseBreakdown()) {
            <div>
              @for (charge of priceItem.chargesApplied; track charge) {
                <p class="body-small">
                  {{ charge.name }}
                </p>
              }
            </div>
          }
          {{ priceItem.incoterm }}
        </td>

        <td class="text-right">
          @if (verboseBreakdown()) {
            <div>
              @for (charge of priceItem.chargesApplied; track charge) {
                <p class="body-small">-</p>
              }
            </div>
          }
          {{ priceItem.moneyAmount.currency.symbol }}
        </td>

        <td class="text-right">
          @if (verboseBreakdown()) {
            <div>
              @for (charge of priceItem.chargesApplied; track charge) {
                <p class="body-small text-right">
                  {{ charge.moneyAmount.amount | number: "1.4" }}
                </p>
              }
            </div>
          }
          <p class="text-right">
            {{ priceItem.moneyAmount.amount }}
          </p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
